import React from "react";
import { Typography } from "@genie-ui/react";
import "./NoResultText.scss";
const NoResultText = ({ children }) => {
  return (
    <Typography className="search__no-result" variant="body3">
      <i>{children}</i>
    </Typography>
  );
};

export default NoResultText;
